module.exports = __webpack_public_path__ + "static/media/nd8.e1729d8e.webp";